// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/BespokeReviews/index.css
// module id = 2622
// module chunks = 0